<div class="rounded-sm h-auto border rounded border-orange relative"
     [ngClass]="{'shadow-xl': !isShrunk}"
     *appIfAccountFeatureFlag="AccountFlagEnum.IS_AVAILABLE_TRADING_HUB">

<span class="trading-hub-sidebar-label bg-orange text-white text-xs px-2 absolute rounded -top-3 font-bold whitespace-normal"
      [ngClass]="{'trading-hub-sidebar-label--hidden': isShrunk}"
      style="top:-7px; left: 50%;"
      i18n>
        DRAŽBE VOZIL
      </span>

  <span style="display: none" #translatedTooltipMessage i18n>Število novih dražb, ki so bile objavljene danes</span>
  <app-sidebar-item
          [imgSrc]="'assets/images/icons/trading_hub_euro_icon.png'"
          [label]="tradingHubSideBarItemLabel"
          [title]="tradingHubSideBarItemLabel"
          [route]="['/admin/trading/dashboard']"
          [isShrunk]="isShrunk"
          [permission]="PermissionEnum.MENU_GLOBAL_TRADING_HUB_VIEW"
          [notificationCount]="tradingHubNotificationCount"
          [notificationTooltip]="translatedTooltipMessage?.innerText"
          [showAdditionalText]="showAdditionalText"
  />

  <ng-container *appIfAccountFeatureFlag="[AccountFlagEnum.IS_AVAILABLE_TRADING_HUB_ADVERTISING]">
    <app-sidebar-item
            [icon]="'fas fa-user-shield'"
            [label]="tradingHubAdminPageSideBarItemLabel"
            [title]="tradingHubAdminPageSideBarItemLabel"
            [route]="['/admin/trading/admin-dashboard']"
            [isShrunk]="isShrunk"
            [permission]="PermissionEnum.MENU_GLOBAL_TRADING_HUB_VIEW"
    />
  </ng-container>
</div>
